import { RegisterEvent } from './v1';
export const REGISTER_EVENT_OPTIONS = {
    bubbles: true,
    composed: true,
};
export const REGISTER_EVENT_NAME = 'register';
export function clone(event) {
    if ('clone' in event) {
        return event.clone();
    }
    return RegisterEvent.from(event);
}
export function eventInitOf(event) {
    return {
        bubbles: event.bubbles,
        cancelable: event.cancelable,
        composed: event.composed,
    };
}
//# sourceMappingURL=common.js.map